// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__wOZfd","requiredAsterisk":"Info_requiredAsterisk__natF6"};